import { render } from "./BaseAddresses.vue?vue&type=template&id=66d3b368"
import script from "./BaseAddresses.vue?vue&type=script&lang=js"
export * from "./BaseAddresses.vue?vue&type=script&lang=js"

import "./BaseAddresses.vue?vue&type=style&index=0&id=66d3b368&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__